@if (loading()) {
  <div class="eventq-info-card eventq-info-card--loading" aria-hidden="true">
    <div class="eventq-info-card__skeleton">
      <div class="eventq-info-card__skeleton-header">
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--category"></span>
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--title"></span>
      </div>
      <div class="eventq-info-card__skeleton-meta">
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--meta-label"></span>
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--meta-value"></span>
      </div>
      <div class="eventq-info-card__skeleton-note">
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--note-label"></span>
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--note-text"></span>
        <span class="eventq-info-card__skeleton-line eventq-info-card__skeleton-line--note-text-short"></span>
      </div>
    </div>
  </div>
} @else {
  <div class="eventq-info-card">
    <div class="eventq-info-card__header">
      @if (category()) {
        <p class="eventq-info-card__category">{{ category() }}</p>
      }
      <p class="eventq-info-card__title">{{ title() }}</p>
    </div>

    @if (meta().length) {
      <div class="eventq-info-card__meta" [style.grid-template-rows]="metaRowTemplate()">
        @for (item of meta(); track $index) {
          <div
            class="eventq-info-card__meta-item"
            [class.eventq-info-card__meta-item--rows]="isRowList(item)"
          >
            <p class="eventq-info-card__meta-label">{{ item.label }}</p>
            @for (row of metaRows(item); track $index) {
              <p class="eventq-info-card__meta-value">{{ row }}</p>
            }
          </div>
        }
      </div>
    }

    @for (note of resolvedNotes(); track $index) {
      <div class="eventq-info-card__note">
        <p class="eventq-info-card__note-label">{{ note.label }}</p>
        <p class="eventq-info-card__note-text">{{ note.text }}</p>
      </div>
    }
  </div>
}
